export class Categoria {
    id: number;
    nombre: string;
    estaActivo: boolean;
}
